import { organisationConstants } from '../../../_constants/organisation.constants';

const initialState = { uploaded_assessment_responses_loading : true, uploaded_assessment_responses_data: '', uploaded_assessment_responses_error_data : '', uploaded_assessment_responses_error: false};

export function uploadAssessmentResponses(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_UPLOAD_ASSESSMENT_RESPONSES_API:
        return {
            uploaded_assessment_responses_loading: true,
            uploaded_assessment_responses_data: '',
            uploaded_assessment_responses_error_data: '',
            uploaded_assessment_responses_error: false
        };
      case organisationConstants.RECIEVE_UPLOAD_ASSESSMENT_RESPONSES_API:
        return {
            uploaded_assessment_responses_loading: false,
            uploaded_assessment_responses_data: action.uploaded_assessment_responses.data,
            uploaded_assessment_responses_error_data: '',
            uploaded_assessment_responses_error: false
        };
      case organisationConstants.ERROR_UPLOAD_ASSESSMENT_RESPONSES_API:
        return { 
            uploaded_assessment_responses_loading: false,
            uploaded_assessment_responses_data: '',
            uploaded_assessment_responses_error_data: action.error.response.data.message,
            uploaded_assessment_responses_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/uploadCsv/uploadAssessmentResponses.reducer.js